import "./footer.css";

import React from "react";

import { ARTISTS, CONTACT_DETAILS, CONTACT_FORM } from "../../data/content";
import { CONTACT_FORM_ID, useEnquiry } from "../general/Enquiry";
import { postRequest } from "../../utils/apiHandlers";

const EMPTY = {
  name: "",
  email: "",
  phone: "",
  artist: "",
  message: "",
  artwork: "",
  website: "", //Honeypot
};

//Same list as the Wix drop-down, plus Ardmore
const ARTIST_OPTIONS = [...ARTISTS.map((a) => a.name), "Ardmore Ceramics"];

const Field = ({ label, isRequired = false, className = "", children }) => (
  <label className={`contact-field ${className}`}>
    <span className={"contact-label"}>
      {label}
      {isRequired ? <span aria-hidden={"true"}> *</span> : null}
    </span>
    {children}
  </label>
);

const WhatsAppIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.23 8.23 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.22 8.23zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.16.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.13-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31-.22.25-.86.85-.86 2.07 0 1.22.89 2.4 1.01 2.56.12.17 1.75 2.67 4.23 3.74.59.26 1.05.41 1.41.52.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.1-.22-.16-.47-.28z"} />
  </svg>
);

const FacebookIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M13.5 22v-8.2h2.75l.41-3.2H13.5V8.56c0-.93.26-1.56 1.59-1.56h1.69V4.14A22.6 22.6 0 0 0 14.32 4c-2.44 0-4.11 1.49-4.11 4.22v2.37H7.45v3.2h2.76V22h3.29z"} />
  </svg>
);

const InstagramIcon = () => (
  <svg
    viewBox={"0 0 24 24"}
    aria-hidden={"true"}
  >
    <path d={"M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.06.41 2.23.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.23-.22.56-.48.96-.9 1.38-.42.42-.82.68-1.38.9-.42.16-1.06.36-2.23.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.72 3.72 0 0 1-1.38-.9 3.72 3.72 0 0 1-.9-1.38c-.16-.42-.36-1.06-.41-2.23C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.06-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16zM12 0C8.74 0 8.33.01 7.05.07 5.78.13 4.9.33 4.14.63c-.79.3-1.46.72-2.13 1.38A5.88 5.88 0 0 0 .63 4.14C.33 4.9.13 5.78.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.06 1.27.26 2.15.56 2.91.3.79.72 1.46 1.38 2.13a5.88 5.88 0 0 0 2.13 1.38c.76.3 1.64.5 2.91.56C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c1.27-.06 2.15-.26 2.91-.56a5.88 5.88 0 0 0 2.13-1.38 5.88 5.88 0 0 0 1.38-2.13c.3-.76.5-1.64.56-2.91.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.26-2.15-.56-2.91a5.88 5.88 0 0 0-1.38-2.13A5.88 5.88 0 0 0 19.86.63C19.1.33 18.22.13 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-11.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"} />
  </svg>
);

//"Contact Us" form, address and social links at the bottom of every page (as on Wix)
const Footer = () => {
  const { prefill } = useEnquiry();
  const [form, setForm] = React.useState(EMPTY);
  const [isSending, setIsSending] = React.useState(false);
  const [errorText, setErrorText] = React.useState("");
  const [sentTo, setSentTo] = React.useState(null);
  const messageRef = React.useRef(null);

  //An artwork page's "Enquire" button fills in the artist and artwork
  React.useEffect(() => {
    if (!prefill) {
      return;
    }
    setSentTo(null);
    setErrorText("");
    setForm((current) => ({
      ...current,
      artist: ARTIST_OPTIONS.includes(prefill.artist) ? prefill.artist : current.artist,
      artwork: prefill.artwork,
      message: `${prefill.artwork} - Enquiry\n`,
    }));
    //Wait for the smooth scroll before moving the cursor into the message
    const timeout = window.setTimeout(() => {
      if (messageRef.current) {
        messageRef.current.focus({ preventScroll: true });
      }
    }, 600);
    return () => window.clearTimeout(timeout);
  }, [prefill]);

  const update = (prop) => (e) => setForm({ ...form, [prop]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorText("");
    setIsSending(true);
    try {
      await postRequest("/Contact/SendContactMessage", form);
      setSentTo(form.name);
      setForm(EMPTY);
    }
    catch (err) {
      setErrorText(err.message);
    }
    setIsSending(false);
  };

  return (
    <footer
      id={CONTACT_FORM_ID}
      className={"site-footer"}
    >
      <div className={"site-footer-inner"}>
        <h2 className={"section-title"}>{CONTACT_FORM.TITLE}</h2>

        {sentTo !== null ? (
          <div
            className={"contact-success"}
            role={"status"}
          >
            <p>Thank you for your enquiry{sentTo ? `, ${sentTo}` : ""}! We&apos;ll be in touch soon.</p>
            <button
              type={"button"}
              className={"btn"}
              onClick={() => setSentTo(null)}
            >
              Send another enquiry
            </button>
          </div>
        ) : (
          <form
            className={"contact-form"}
            onSubmit={onSubmit}
          >
            <Field label={"Name"}>
              <input
                type={"text"}
                value={form.name}
                onChange={update("name")}
                maxLength={100}
                autoComplete={"name"}
              />
            </Field>
            <Field
              label={"Email"}
              isRequired
            >
              <input
                type={"email"}
                value={form.email}
                onChange={update("email")}
                required
                maxLength={200}
                autoComplete={"email"}
              />
            </Field>
            <Field
              label={"Phone"}
              className={"is-full"}
            >
              <input
                type={"tel"}
                value={form.phone}
                onChange={update("phone")}
                maxLength={50}
                autoComplete={"tel"}
              />
            </Field>
            <Field
              label={CONTACT_FORM.ARTIST_LABEL}
              className={"is-full"}
            >
              <select
                value={form.artist}
                onChange={update("artist")}
              >
                <option value={""}>Select an artist (optional)</option>
                {ARTIST_OPTIONS.map((name) => (
                  <option
                    key={name}
                    value={name}
                  >
                    {name}
                  </option>
                ))}
              </select>
            </Field>
            <Field
              label={CONTACT_FORM.MESSAGE_LABEL}
              isRequired
              className={"is-full"}
            >
              <textarea
                ref={messageRef}
                value={form.message}
                onChange={update("message")}
                required
                maxLength={5000}
                rows={3}
                placeholder={CONTACT_FORM.MESSAGE_PLACEHOLDER}
              />
            </Field>
            <label
              className={"contact-honeypot"}
              aria-hidden={"true"}
            >
              Website
              <input
                type={"text"}
                value={form.website}
                onChange={update("website")}
                tabIndex={-1}
                autoComplete={"off"}
              />
            </label>

            {errorText ? (
              <p
                className={"contact-error is-full"}
                role={"alert"}
              >
                {errorText}
              </p>
            ) : null}

            <div className={"is-full"}>
              <button
                type={"submit"}
                className={"btn contact-submit"}
                disabled={isSending}
              >
                {isSending ? "Sending..." : "Submit"}
              </button>
            </div>
          </form>
        )}

        <div className={"footer-details"}>
          <address>
            <a
              href={CONTACT_DETAILS.MAP_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
            >
              {CONTACT_DETAILS.ADDRESS.map((line) => (
                <React.Fragment key={line}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </a>
          </address>
          <p className={"footer-contact"}>
            {CONTACT_DETAILS.CONTACT_NAME}
            <br />
            <a href={`mailto:${CONTACT_DETAILS.EMAIL}`}>{CONTACT_DETAILS.EMAIL}</a>
            <br />
            <a href={CONTACT_DETAILS.PHONE.link}>{CONTACT_DETAILS.PHONE.label}</a>
          </p>
        </div>

        <ul className={"footer-social"}>
          <li>
            <a
              href={CONTACT_DETAILS.WHATSAPP_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
              aria-label={"WhatsApp"}
            >
              <WhatsAppIcon />
            </a>
          </li>
          <li>
            <a
              href={CONTACT_DETAILS.FACEBOOK_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
              aria-label={"Facebook"}
            >
              <FacebookIcon />
            </a>
          </li>
          <li>
            <a
              href={CONTACT_DETAILS.INSTAGRAM_LINK}
              target={"_blank"}
              rel={"noopener noreferrer"}
              aria-label={"Instagram"}
            >
              <InstagramIcon />
            </a>
          </li>
        </ul>

        <p className={"footer-copyright"}>
          &copy; {new Date().getFullYear()} Charles Greig Gallery
          <br />
          Website by{" "}
          <a
            href={CONTACT_DETAILS.CREDIT.link}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            {CONTACT_DETAILS.CREDIT.label}
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
